import TaskDetail from './TaskDetail'

/**
 * The single page behind `/projects/:projectId/tasks/:taskId`, for every task kind.
 *
 * There is no longer any id-prefix routing: ONE renderer (`TaskDetail`) fetches the unified
 * task-detail envelope (`GET /api/task-detail/:id`) for whatever id it's given — a container task
 * (`task-…`), a test run (`run-…`), an exploration (`expl-…`), or a polish pass (`pass-…`) — and
 * renders every section it has data for.
 */
export default function TaskPage() {
  return <TaskDetail />
}
